import { render, staticRenderFns } from "./ExpandButton.vue?vue&type=template&id=53deeed2&scoped=true"
import script from "./ExpandButton.vue?vue&type=script&lang=ts"
export * from "./ExpandButton.vue?vue&type=script&lang=ts"
import style0 from "./ExpandButton.vue?vue&type=style&index=0&id=53deeed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53deeed2",
  null
  
)

export default component.exports